<template>
    <div class="my_goods_car">
        <div>
            <div>
                <el-card style="margin-top: 40px; ">
                <el-row >
                    <el-col :span="6">客户名称:<span>{{vip_custom_info.vip_custom_name}}</span></el-col>
                    <el-col :span="6">联系方式:<span>{{vip_custom_info.vip_custom_phone}}</span></el-col>
                    <el-col :span="6">地区:<span>{{vip_custom_info.province_name}}{{vip_custom_info.city_name}}{{vip_custom_info.area_name}}</span></el-col>
<!--                    <el-col :span="6">详细地址:<span>{{vip_custom_info.address}}</span></el-col>-->
                </el-row>
                </el-card>
            </div>
            <el-card style="margin-top: 20px;">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="摘要信息" name="first">
                    <record_custom :custom-hash="detailHash" :custom_record_data="custom_record_data"></record_custom>
                    </el-tab-pane>
                    <el-tab-pane label="详细信息" name="second">
                        <custom_info :item="vip_custom_info"></custom_info>
                    </el-tab-pane>
                    <el-tab-pane label="相关团队" name="third">
                        <team_custom :custom-hash="detailHash" :table-data="custom_union_data"></team_custom>
                    </el-tab-pane>
                    <el-tab-pane label="在线方案" name="fourth">
                        <program_custom :table-data="custom_scheme_data"></program_custom>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </div>
    </div>
</template>

<script>
import record_custom from "../components/custom_detail/record_custom";
import custom_info from "../components/custom_detail/custom_info";
import team_custom from "../components/custom_detail/team_custom";
import program_custom from "../components/custom_detail/program_custom";
export default {
  name: "custom_detail",
  components:{
    record_custom,
    custom_info,
    team_custom,
    program_custom,
  },
  data(){
    return {
      detailHash:'',
      vip_custom_info:'',
      activeName:"first",
      custom_union_data:[],
      custom_record_data:[],
      custom_scheme_data:[],
    }
  },
  methods:{
    handleClick(){

    },
    //请求数据
    getCustomViewData(){
      this.$http({
        url: 'vip_custom_view',
        data: {
          vip_custom_hash: this.detailHash,
        },
      }).then(res => {
        if (res.code == 1) {
          console.log(res.data);
        this.vip_custom_info = res.data.vip_custom_info;
        this.custom_union_data = res.data.custom_union_data;
        this.custom_record_data = res.data.custom_record_data;
        this.custom_scheme_data= res.data.custom_scheme_data;
        console.log(this.vip_custom_hash)
        }
        console.log(res);
      }).catch((err) => {
        console.log(err)
      });
    }
  },
  created() {
    this.detailHash = this.$route.params.hash;
    this.getCustomViewData();
  }

}
</script>

<style scoped>
    .my_goods_car {
        /*background: #F7F7F5;*/
        box-sizing: border-box;
        padding-top: 46px;
        margin-left: 40px;
        margin-right: 40px;
    }
    .el-col{
        color: #18181c;
        font-size: 12px;
        line-height: 22px;
        font-weight: 500px;
    }
    .el-col>span{
        color: #18181c;
        font-size: 12px;
        font-weight: 400px;
        padding-left: 10px;
    }
</style>
